export const teacherOptions = [
  { value: 1, label: '未联系文案老师' },
  { value: 2, label: '已联系文案老师' }
];
export const booleanOptions = [
  { value: 1, label: '否' },
  { value: 2, label: '是' }
];
export const submitOrgOptions = [
  { value: 1, label: '未提交' },
  { value: 2, label: '已提交' }
];
export const materialFinish = [
  { value: 1, label: '初级' },
  { value: 2, label: '中级' },
  { value: 3, label: '高级' },
];
export const handleState = [
  { value: 1, label: '申请中' },
  { value: 2, label: '延期中' },
  { value: 3, label: '已退办' },
  { value: 4, label: '未开始' }
];
export const insideFinal = [
  { value: 1, label: '未通过' },
  { value: 2, label: '已通过' }
];
export const deliverState = [
  { value: 1, label: '未交付' },
  { value: 2, label: '已交付' }
];
export const delayState = [
  { value: 1, label: '无延期史' },
  { value: 2, label: '有延期史' }
];
